import type { Notifications } from '../types';
import { getInboxUnreadCount } from './get-inbox-unread-count';

/**
 * Get the total notification count for the user. This is shown in the header
 * user button as a badge count.
 * @param notifications The notifications object.
 * @param orderNotificationCount The order notification count (from the User object).
 * @param newChatUI2025Enabled The `new_chat_ui_2025` feature flag is enabled.
 * @returns The total notification count.
 */
export function getTotalNotificationCount(
    notifications: Notifications,
    orderNotificationCount: number,
    newChatUI2025Enabled: boolean = false,
): number {
    const inboxUnreadCount = getInboxUnreadCount(
        notifications,
        newChatUI2025Enabled,
    );

    return (
        notifications.website.count + inboxUnreadCount + orderNotificationCount
    );
}
